import styled from '@emotion/styled';
import {
  headerTopHeight,
  layoutMaxWidth,
  layoutPadding,
} from '../../layout-styles';
import Profile from '../Profile';
import Spacer from '@/components/comm/Spacer';
import { breakpointSmall } from '@/constants/breakpoints';

const Container = styled.div`
display: flex;
width: 100%;
max-width: ${layoutMaxWidth};
height: ${headerTopHeight};
padding: ${layoutPadding};
`;

const Anchor = styled.a`
display: grid;
align-items: center;
padding: 0 16px;
@media (max-width: ${breakpointSmall}) {
  padding: 0 12px;
}
`;

const TextAnchor = styled(Anchor)`
margin-left: -16px;
color: #AEAEAE;
font-size: 14px;
font-weight: 500;
line-height: 22px;
@media (max-width: ${breakpointSmall}) {
  font-size: 13px;
}
`;

const Upper = () => (
  <Container>
    <TextAnchor href="https://programmers.co.kr/">
      프로그래머스로 이동
    </TextAnchor>
    <Spacer />
    <Profile />
  </Container>
);

export default Upper;
